/* oxlint-disable react/forbid-elements -- Original profile arrows from the approved export. */
import { people } from '../../../content/career/cards';
import * as React from 'react';
import { cx } from '../../../components/CareerLayout/styles';
import * as media from '../../../assets/career/media';

export const People: React.FC = () => (
  <section id="people" className={cx('main_section_people')}>
    <div className={cx('padding-global padding-section-medium')}>
      <div className={cx('container-large')}>
        <div className={cx('main_content_people')}>
          <h2>
            <span className={cx('text-color-brand-blue')}>{'Люди,которые двигают'}</span>
            <br />
            {'рынок недвижимости'}
          </h2>
        </div>
      </div>
    </div>
    <div className={cx('main_people_image-wrapper')}>
      <img src={media.mainPeopleBgImageConverted} loading="lazy" alt="" className={cx('main_people_bg-image')} />
      <div className={cx('main_people_mobile-cards-layout')}>
        {people.map(person => (
          <div key={person.slug} className={cx('main_people_card-wrapper ' + person.position)}>
            <article className={cx('main_people_card')}>
              <img
                src={person.image}
                srcSet={person.srcSet}
                sizes="(max-width: 767px) 45vw, 280px"
                loading="lazy"
                alt=""
                className={cx('main_people_card-image')}
              />
              <h3>{person.name}</h3>
              <div className={cx('hide-mobile-landscape')}>{person.role}</div>
              <button
                type="button"
                aria-label={`Подробнее о сотруднике ${person.name}`}
                className={cx('main_people_link')}
              >
                <svg viewBox="0 0 32 26" fill="none" className={cx('icon-1x1-medium')} aria-hidden="true">
                  <path
                    d="M0 12.57L29.65 12.55M18.35 24.22L30 12.55L18.35.88"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  />
                </svg>
              </button>
            </article>
          </div>
        ))}
      </div>
    </div>
  </section>
);
